import { searchFilter } from './searchFilter'

export const actions = Object.assign({}, searchFilter)
